import {
    HttpResponse,
    ShiftScrapRecordModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class ShiftScrapRecordsDataService implements CrudService<ShiftScrapRecordModel, ShiftScrapRecordModel> {
    getAll(query: CrudDataQuery<ShiftScrapRecordModel>): Promise<CrudEnumerableResponse<ShiftScrapRecordModel>> {
        return ApiService.api.getShiftScrapRecordBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<ShiftScrapRecordModel>): Promise<CrudEnumerableResponse<ShiftScrapRecordModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ShiftScrapRecordModel>> {
        return ApiService.api.getShiftScrapRecordById(id, params);
    }

    create(item: ShiftScrapRecordModel, params?: RequestParams): Promise<CrudResponse<ShiftScrapRecordModel>> {
        return ApiService.api.insertShiftScrapRecord(item, params);
    }

    update(item: ShiftScrapRecordModel, params?: RequestParams): Promise<ShiftScrapRecordModel> {
        return ApiService.api.updateShiftScrapRecord(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ShiftScrapRecordModel> {
        return ApiService.api.patchShiftScrapRecord(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ShiftScrapRecordModel>): Promise<CrudEnumerableResponse<ShiftScrapRecordModel>> {
        return ApiService.api.deleteShiftScrapRecords(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationShiftScrapRecord(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<ShiftScrapRecordModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: ShiftScrapRecordModel, params?: RequestParams): Promise<CrudResponse<ShiftScrapRecordModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getShiftScrapRecordGroupped(query, params);
    }

}
